import { render } from "./FormCamera.vue?vue&type=template&id=51acfaef"
import script from "./FormCamera.vue?vue&type=script&lang=js"
export * from "./FormCamera.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__